import {RouteRecordRaw } from 'vue-router'
// 广告路由

/**
 * meta:{
 *     title:'登录', 页面标题/菜单标题
 *     icon:'',     菜单图标
 *     hidden:true, 是否在菜单中以隐藏
 *     hiddenTab:true 是否在tab栏中隐藏
 * 
 * }
 */

 export const adRoutes: Array<RouteRecordRaw> = [
    {
      path: '/ad_coachPromoter',
      component: ()=>import('@/views/ad/coachPromoter.vue'),
      meta:{
        title:'教练合作新模式',
        icon:'dashboard',
        mode: 'ad',
        hidden:true,
        hiddenTab:true
      },
      children: []
    },
    {
      path: '/ad_ai',
      component: ()=>import('@/views/ad/aiview.vue'),
      meta:{
        title:'海马AI',
        icon:'dashboard',
        mode: 'ad',
        hidden:true,
        hiddenTab:true
      },
      children: []
    }
  ]